(function () {
  const open_class = 'size-guide--open';

  const root = document.querySelector('[data-size-guide-root]');
  if (root && !root.hasAttribute('data-size-guide-ported')) {
    document.body.appendChild(root);
    root.setAttribute('data-size-guide-ported', 'true');
  }

  function getRoot() {
    return document.querySelector('[data-size-guide-root]');
  }

  function openGuide(root) {
    if (!root) return;
    root.classList.add(open_class);
    root.setAttribute('aria-hidden', 'false');
    root.classList.add('overflow_hidden');
  }

  function closeGuide(root) {
    if (!root) return;
    root.classList.remove(open_class);
    root.setAttribute('aria-hidden', 'true');
    root.classList.remove('overflow_hidden');
  }

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-size-guide-open]');
    if (openBtn) return openGuide(getRoot());
    if (e.target.closest('[data-size-guide-close]') || e.target.closest('[data-size-guide-overlay]')) {
      return closeGuide(getRoot());
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeGuide(getRoot());
  });
})();
